export {default as Confirm} from './Confirm';
export {default as DialogActions} from './Actions';
export {default as DialogContent} from './Content';
export {default as DialogTitle} from './Title';
export {default as Dialog} from './GenericDialog';
export * from './Confirm';
export * from './GenericDialog';